module.exports = __webpack_public_path__ + "img/logo.19dad8c0.png";